import React from "react";
import { Main } from "../../../features/risk/pages/global-risk-map";

import IncidentDetailsModalProvider from "../../../context/incident-details-modal";
import {IncidentMapPage} from "@/pages/incidents/incident-map";
function GlobalRiskMap() {
  return (
   <IncidentMapPage/>
  );
}

export default GlobalRiskMap;
